import { QueryKey } from '@/lib/query-client';
import { getAllProviders } from '@/lib/services/context-provider.service';
import { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import ListToggle from '../list-toggle';
import { FormProps } from '../helpers';
import { UiOption } from '@/lib/helpers';
import useQueryHelper from '@/hooks/use-query-helper';

interface Props extends FormProps {
  value: string[];
  onChange: (options: UiOption[]) => void;
}

const DatasourcesListToggle: FC<Props> = (props) => {
  const query = useQuery([QueryKey.ContextProvidersList], async () => getAllProviders());
  const { data } = query;
  const { showLoader } = useQueryHelper(query);

  const datasourceOptions = useMemo(() => {
    return (data || []).map(({ id, name }) => ({
      value: id,
      label: name,
    }));
  }, [data]);

  return (
    <ListToggle
      {...props}
      options={datasourceOptions}
      leftTitle="Available Data Sources"
      rightTitle="Assigned Data Sources"
      loadState={showLoader ? 'loading' : 'loaded'}
    />
  );
};

export default DatasourcesListToggle;
